import StatContextProvider, { useStatContext } from './CreditFlowStatContext';

export { useStatContext };
export default StatContextProvider;
